<template>
  <div class="box">
    <com-h1 title="参会须知"></com-h1>
    <section class="tabs">
      <span class="fill"></span>
      <span class="tab" :class="{show: curTab==0}"  @click="curTab=0">报名流程</span>
      <span class="tab" :class="{show: curTab==1}"  @click="curTab=1">周边酒店</span>
      <span class="fill"></span>
    </section>

    <div class="path" v-show="curTab==0">
      <section class="chart">
        <div class="container">
          <router-link :to="'/apply'">
            <img class="img" src="../../assets/about/process_3.svg">
          </router-link>
          <section class="contact">
            <li>手机：{{contact.book.value}}</li>
            <li>微信：{{contact.book.value}}</li>
            <li>邮箱：{{contact.email.value}}</li>
          </section>
        </div>
      </section>
      <section class="payinfo">
        <div class="container">
          <div class="title">付款方式</div>

          <div class="columns fla">
            <div class="column is-half">
              <div class="account">
                <div class="title">主办方对公收款账号</div>
                <div class="recive">
                  <p>户名：北京极客邦科技有限公司</p>
                  <p>账号：1109 1341 9210 103</p>
                  <p>开户行：招商银行股份有限公司北京望京支行</p>
                  <p>公司名称：北京极客邦科技有限公司</p>
                  <blockquote>备注：企业名称＋购票人姓名</blockquote>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="account">
                <div class="title">主办方支付宝收款账号</div>
                  <div class="recive">
                  <p>户名：北京极客邦科技有限公司</p>
                  <p>账号：ASSZ@geekbang.org</p>
                  <blockquote>备注：此方法转账需发转账截图至微信{{contact.book.value}}，方便与财务核对</blockquote>
                </div>
              </div>
            </div>
          </div>
          <div class="content2">
            <ol>
              <li>汇款时在备注中请注明（AS＋购票者的姓名），以便我们尽快为您核实信息 </li>
              <li>请将汇款凭证发至邮箱（{{contact.email.value}}）或添加票务经理（QQ 2332883546/微信 aschina666），以尽快获取电子票</li>
            </ol>
          </div>
        </div>
      </section>
      <section>
        <div class="container content2">
          <h2>注册报名</h2>
          <p>请根据大会网站的注册表单认真填写在线报名注册信息（请准确填写姓名、手机、常用邮件等带有“*”号键信息，用于接收电子门票及其他相关资料信息）。</p>
          <h2>付款</h2>
          <p>请根据自己所选择的票类，通过在线支付或银行转账的方式支付相关票款。</p>
          <h2>获取大会电子门票</h2>
          <ol>
            <li>选择在线支付（支付宝）方式汇款的个人或企业，在付款成功后，可直接获取电子门票邮件一封（在您的注册邮箱里），请下载附件的电子门票文件，并保存到你的电脑或手机里。如未在 1 小时之内获取邮件信息，请及时联系 ArchSummit 会务组，电话 ({{contact.book.value}}) 、邮件（{{contact.email.value}}）；</li>
            <li>选择通过银行转账方式汇款的个人或是企业，请汇款之后保留汇款凭证，电话 ({{contact.book.value}}) 、邮件（{{contact.email.value}}）通知组委会购票人的姓名及汇款金额，收到款项后会发送电子门票至参会者邮箱。</li>
          </ol>
          <h2>凭电子门票参会</h2>
          <p>请根据大会网站的注册表单认真填写在线报名注册信息（请准确填写姓名、手机、常用邮件等带有“*”号键信息，用于接收电子门票及其他相关资料信息）。</p>
          <h2>发票开具流程</h2>
          <ol>
            <li>确认收到购票方的票款；</li>
            <li>工作人员与购票方联系人及时通过邮件沟通发票信息，请购票方确认发票信息 100% 无误；</li>
            <li>在无外力因素的情况下，发票将在 7 个工作日开具并快递；</li>
            <li>每月 25 日至下月 8 日，财务在报税过程中不能开具发票，请各位亲理解，请尽量付款错开这个时间段；</li>
            <li>会务组规定，在收到购票方票款后，方可按照实际总金额开具，如您有特殊需求，可及时找主办方沟通。</li>
          </ol>
          <h2>门票费用中包含</h2>
          <ol>
            <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}大会通票，包含所有主题演讲、专题演讲以及厂商共建专场（不包含闭门会议）；`}}</li>
            <li>大会期间展区参观或参与互动，各种小礼品的搜集；</li>
            <li>晚场活动的参与，与讲师面对面交流的机会；</li>
            <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}2天午餐，签到时发送，丢失不补哦（不含晚餐）；`}}</li>
            <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}茶歇等；`}}</li>
            <li>大会通票不包含培训，如有参与培训需求，请购买大会套票或培训票</li>
          </ol>
          <!-- <h2>VIP票费用中包含</h2>
          <ol>
            <li>“大会通票”所有权益；</li>
            <li>参加为大会讲师及TGO会员特别策划的所有高端社交活动，如早餐会、闭门会议、设计晚宴等；</li>
            <li>优先获得与讲师深度交流的机会。</li>
          </ol> -->
          <h2>团队报名（ 5 人以上，含 5 人）流程</h2>
          <ol>
            <li>电话或邮件联系组委会申请团队优惠价；</li>
            <li>成员信息填写在线注册报名（有负责人统一填写报名信息），报名成功后致电 ({{contact.book.value}}) 、邮件（{{contact.email.value}}）通知 AS 会务组；</li>
            <li>按照团购价格付款；</li>
            <li>联系主办方获取大会电子门票；</li>
            <li>凭电子门票（或彩信/短信）签到参会。</li>
          </ol>
          <blockquote>
            <p>注：</p>
            <ol>
              <li>在规定时间前成功将参会费用汇入组委会指定票务组银行账号，享受相应折扣，否则优惠期将自动延后</li>
              <li>网上的注册日期在限时优惠的截止日期之内，以收到参会者的票款日期为准</li>
              <li>以上票价不包括住宿费</li>
            </ol>
          </blockquote>
          <h2>特别说明</h2>
          <p><b>请仔细阅读以下说明：</b></p>
          <ol>
            <li>门票一旦购买，恕不退票；</li>
            <li>如您在购票后因故不能参加大会，请至少提前十个工作日将门票转让他人（转让门票请联系本次活动的主办方进行票务信息更改） ，会议开始前十个工作日内不接受转让门票；</li>
            <li>电子门票是大会现场换取入场证的唯一凭证，请自行打印并妥善保管；</li>
            <li>如果门票遗失，请您及时与主办方联系；</li>
            <li>遇到极端情况会议取消，主办方责任仅限于退回已支付的票款。</li>
          </ol>
        </div>
      </section>
    </div>
    <div class="hotel" v-show="curTab==1">
      <hotel :data="{'version': hotel.version}"></hotel>
    </div>

  </div>
</template>

<script>
import ComH1 from '@/components/com-h1'
import Hotel from './hotel/index.vue'
import util from '@/utils'
import moment from 'moment'

export default {
  components: {
    ComH1,
    Hotel
  },
  data () {
    return {
      curTab: 0
    }
  },
  computed: {
    hotel () {
      return this.$store.state.comConfig['about'].hotel
    },
    conTimeInfo () {
      let conTimeInfo = {
        beginTime: '',
        endTime: '',
        beginTimeTraining: '',
        endTimeTraining: ''
      }
      if (this.$store.state.info.beginTime) {
        conTimeInfo.beginTime = moment(this.$store.state.info.beginTime).utcOffset('+08:00').format('MM月DD日')
      }
      if (this.$store.state.info.endTime) {
        conTimeInfo.endTime = moment(this.$store.state.info.endTime).utcOffset('+08:00').format('MM月DD日')
      }
      if (this.$store.state.info.beginTime && this.$store.state.info.endTime) {
        let beginTimeFormat = moment(this.$store.state.info.beginTime).utcOffset('+08:00').format('YYYY-MM-DD')
        let endTimeFormat = moment(this.$store.state.info.endTime).utcOffset('+08:00').format('YYYY-MM-DD')
        conTimeInfo.duringCon = Math.floor(Math.abs((Date.parse(endTimeFormat) - Date.parse(beginTimeFormat)))) / (24 * 3600 * 1000) + 1
      }
      if (this.$store.state.info.beginTimeTraining) {
        conTimeInfo.beginTimeTraining = moment(this.$store.state.info.beginTimeTraining).utcOffset('+08:00').format('MM月DD日')
      }
      if (this.$store.state.info.endTimeTraining) {
        conTimeInfo.endTimeTraining = moment(this.$store.state.info.endTimeTraining).utcOffset('+08:00').format('MM月DD日')
      }
      if (this.$store.state.info.beginTime && this.$store.state.info.endTime) {
        let beginTimeTrainingFormat = moment(this.$store.state.info.beginTimeTraining).utcOffset('+08:00').format('YYYY-MM-DD')
        let endTimeTrainingFormat = moment(this.$store.state.info.endTimeTraining).utcOffset('+08:00').format('YYYY-MM-DD')
        conTimeInfo.duringTraining = Math.floor(Math.abs((Date.parse(endTimeTrainingFormat) - Date.parse(beginTimeTrainingFormat)))) / (24 * 3600 * 1000) + 1
      }
      return conTimeInfo
    },
    contact () {
      let contact = { book: '', email: '' }
      this.$store.state.info.contacts.forEach(c => {
        contact[c.key] = c
      })
      return contact
    }
  },
  mounted () {
    util.weixinshare()
  },
  updated () {
    util.weixinshare()
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.tabs
  margin-top: 25px
  width: 100%
  display: flex
  .tab
    background-color: #F5F7F8
    width: 25%
    height: 75px
    line-height: 75px
    text-align: center
    font-size: 20px
    border: 1px solid #D0D7DF
    &:nth-child(n+3)
      border-left: 0
    cursor: pointer
    &.show
      border-bottom: none
      color:  $primary
      background-color: #FFFFFF
    +mobile
      width: 30%
      height: 50px
      line-height: 50px
      font-size: 18px
  .fill
    height: 75px
    flex-grow: 1
    border-bottom: 1px solid #D0D7DF
    +mobile
     height: 50px
.chart
  padding: 30px 0 60px 0
  .container
    width: 870px
    margin: 0 auto
    position: relative
    +mobile
      width: 92vw
    .img
      width: 100%
    .contact
      position: absolute
      right: 20px
      bottom: -20px
      width: 240px
      height: 100px
      background: #f8f8f8
      color: #888
      font-size: 14px
      padding: 0 20px
      display: flex
      flex-direction: column
      justify-content: center
      flex-wrap: nowrap
      line-height: 1.5
      list-style-type: none
      white-space: nowrap
      +mobile
        display: none

.payinfo
  background-color: #f5f8f8
  padding: 30px 0
  .container > .title
    text-align: center
    color: $primary
    font-size: 22px
    margin-bottom: 21px
  .account
    height: 283px
    background-color: #FFFFFF
    border: 1px solid #d5dde3
    +mobile
      height: auto
    .title
      background-color: $primary
      color: #fff
      font-size: 20px
      padding: 15px 50px
      font-weight: 700
      +mobile
        font-size: 16px
        padding: 10px 25px
    .recive
      padding: 30px 50px
      font-size: 17px
      line-height: 1.8
      +mobile
        font-size: 14px
        padding: 20px 25px
      p
        color: #3b3839
      blockquote
        color: #868686
.hotel .light
    background-color: #f5f8f8
.hotel
  // .content2
  //   margin-top: -30px
  // .tip .content2
  //   margin-top: 0
  //   margin-bottom: -30px

// .hotel
  // text-align: left
  // display: block
  // border-bottom: none
  // background-color: #f5f8f8
// .back
//   background-color: #FFFFFF
// .container .img_process
//   margin: 0 auto
//   height: 161px

// .container .img_hotel
  // margin: 0
  // margin-bottom: 21px

// .container .payer
//   font-size: 23px
//   color: #165dae
//   text-align: center
//
// .container .subheader
//   font-size: 18px

</style>
